/**
 * Site search functionality.
 *
 * @author    Mark Shercliff <mark@bareface.agency>
 * @copyright 2016 Bareface
 */
;(function($, window, undefined) {
    var $searchInput = $( '#search-panel-form__input' );

    $('form.search-panel-form').submit(function(e) {
        e.preventDefault();
        $('form.search-panel-form').find( '.btn-search' ).trigger('click');
    });

    $('form.search-panel-form').find( '.btn-search' ).on( 'click', function() {
        var formData = {
            search: $searchInput.val(),
            nonce:  $searchInput.siblings('input[name="nonce"]').val(),
            action: 'kimal_ajax_site_search'
        };

        if (formData.search.length < 3) return;

        $.ajax({
            url:      window.ajaxurl,
            type:     'get',
            dataType: 'html',
            data:     formData,
            success:  function(response) {
                $searchInput.closest('form').find('.search-panel-results').html(response);
            }
        });
    });
})(jQuery, window);
